import bundleMappings from '@/data/bundle-mappings.json';
import type { Equipo, Mascarilla } from '@/context/AppContext';

export interface BundleMapping {
  equipmentId: string;
  maskId: string;
  shopifyHandle: string;
  name: string;
  variants: {
    S: string;
    M: string;
    L: string;
  };
}

// Helper function to convert equipment to ID
export const getEquipmentId = (equipo: Equipo): string => {
  const marca = equipo.marca.toLowerCase();
  const modelo = equipo.modelo.toLowerCase();

  if (marca === 'resmed') {
    if (modelo.includes('11')) {
      return 'resmed-airsense-11';
    }
    return 'resmed-airsense-10';
  } else if (marca === 'yuwell') {
    return 'yuwell-yh-680b';
  }
  throw new Error(`Unknown equipment brand: ${equipo.marca}`);
};

// Helper function to convert mask to ID
export const getMaskId = (mascarilla: Mascarilla): string => {
  const marca = mascarilla.marca.toLowerCase();
  const modelo = mascarilla.modelo.toLowerCase();
  
  if (marca === 'yuwell') {
    if (modelo.includes('yn-03')) {
      return 'yuwell-yn-03';
    } else if (modelo.includes('yf-02')) {
      return 'yuwell-yf-02';
    }
  } else if (marca === 'resmed') {
    if (modelo.includes('n20')) {
      return 'resmed-airfit-n20';
    } else if (modelo.includes('f20')) {
      return 'resmed-airfit-f20';
    }
  }
  
  throw new Error(`Unknown mask: ${mascarilla.marca} ${mascarilla.modelo}`);
};

// Main function to find bundle mapping for selected equipment and mask
export const findBundleMapping = (
  equipo: Equipo, 
  mascarilla: Mascarilla
): BundleMapping | null => {
  try {
    const equipmentId = getEquipmentId(equipo);
    const maskId = getMaskId(mascarilla);
    
    const mapping = bundleMappings.bundles.find(
      bundle => bundle.equipmentId === equipmentId && bundle.maskId === maskId
    );
    
    return mapping || null;
  } catch (error) {
    console.warn('Error finding bundle mapping:', error);
    return null;
  }
};

// Get all available bundle mappings
export const getAllBundleMappings = (): BundleMapping[] => {
  return bundleMappings.bundles;
};